import * as getSelections from './reducers/get';
import * as query from './reducers/query';
import { subscribe, unsubscribe } from './reducers/subscription';
import * as result from './reducers/result';
import * as settle from './reducers/settle';
import * as unsettle from './reducers/unsettle';
import * as moveSelections from './reducers/move-selections';
import { simple } from 'src/utils/reducers';

import * as update from './reducers/update';

// eslint-disable-next-line import/no-default-export
export default simple({
    SELECTIONS_REQUEST: getSelections.request,
    SELECTIONS_ERROR: getSelections.error,
    SELECTIONS_FINISH: getSelections.finish,

    SELECTIONS_UPDATE_REQUEST: update.request,
    SELECTIONS_UPDATE_ERROR: update.error,
    SELECTIONS_UPDATE_FINISH: update.finish,

    SELECTIONS_RESULT_REQUEST: result.request,
    SELECTIONS_RESULT_ERROR: result.error,
    SELECTIONS_RESULT_FINISH: result.finish,

    SELECTIONS_SETTLE_REQUEST: settle.request,
    SELECTIONS_SETTLE_ERROR: settle.error,
    SELECTIONS_SETTLE_FINISH: settle.finish,

    SELECTIONS_UNSETTLE_REQUEST: unsettle.request,
    SELECTIONS_UNSETTLE_ERROR: unsettle.error,
    SELECTIONS_UNSETTLE_FINISH: unsettle.finish,

    SELECTIONS_QUERY_REQUEST: query.request,
    SELECTIONS_QUERY_ERROR: query.error,
    SELECTIONS_QUERY_FINISH: query.finish,

    SELECTIONS_MOVE_REQUEST: moveSelections.request,
    SELECTIONS_MOVE_ERROR: moveSelections.error,
    SELECTIONS_MOVE_FINISH: moveSelections.finish,

    SELECTIONS_SUBSCRIBE: subscribe,
    SELECTIONS_UNSUBSCRIBE: unsubscribe,

    SELECTIONS_DATA: update.bulk,
    SELECTION_DATA: update.update,
});
